import Immutable from "immutable";

const STORAGE_KEY = "activeInDevFeatures";

function update(storage, updater) {
    const updated = updater(Immutable.Set(extractFeatureFlagsFromStorage(storage)));
    if (updated.isEmpty())
        storage.removeItem(STORAGE_KEY);
    else
        storage.setItem(STORAGE_KEY, updated.join(","));
}

export function addFeatureFlagToStorage(storage, feature) {
    update(storage, features => features.add(feature));
}

export function removeFeatureFlagFromStorage(storage, feature) {
    update(storage, features => features.remove(feature));
}

export default function extractFeatureFlagsFromStorage(storage) {
    const activeInDevFeatures = storage.getItem(STORAGE_KEY);
    return activeInDevFeatures ? activeInDevFeatures.split(',') : [];
}
